import { Link } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const EllipsisLink = styled(Link)`
  max-width: calc(36vw);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LightText = styled.span`
  max-width: calc(20vw);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 300;
`;
